export const PRODUCT_ROUTE_PREFIX = "/admin/products";

export const PRODUCT_ROUTE_PATHS = {
  list: { path: "*", to: PRODUCT_ROUTE_PREFIX },
};
